import { render } from "./introDBC.vue?vue&type=template&id=6dc2d37a&scoped=true"
import script from "./introDBC.vue?vue&type=script&lang=js"
export * from "./introDBC.vue?vue&type=script&lang=js"

import "./introDBC.vue?vue&type=style&index=0&id=6dc2d37a&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc2d37a"]])

export default __exports__